import Handler from "../Handler";
class RITPotWinnerHandler extends Handler {
    execute(message) {
      let receivedData = JSON.parse(message);
      this.service.processPotWinner({...receivedData, rit: true});
    }
  }
  
  export default RITPotWinnerHandler;